<template>
    <div class="live-icon relative">
        <div>
            <img width="25" height="25" />
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
$url-icon: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADrElEQVR4nO1YW0tVQRT+orS8dCMI7CVIsbJeSun6oBUElcUx+wdd8CXI6A5RkRRlNwoKfSiSgiCkhyKDUikjeg0qojzdHgrLS2mQFXpiYE7sPtfMHt0H93nYHwxs9v7WzFp7ZtZ8s4AIESJEiJBmWA4gDuA7gK0h+rEFQB+AtwCWDde4AEAXgIRu/QByMPqYrMdO+tGlfXNCNoAXHmPVfoYUSC6AXvLlOYAsF+NzZKjaLoSHnYI/Z/2MlgIYIKNrCB/XyacB7auIMQAek4HaYBMRPnIAvCHfnmqfh6BCmMIypA9WCv7FJCLPRqOl07EAqvRaLUqBk4sB1APYrvs24Rb52MaEYiIM+jh4wcPtBDApQBDTAXR7+jtv4c7Xvnl9XeglnKGPTZbOYsIUlwQIpFT4iTEL/x7xTyU/qA3zkT5WGjpRG/8rcV8ByAwQyDgAL6nPL/oMkbCJuB+Sm76IPvRaDpy9xO3nqR0hiukETwDYYzmwfxB3tvqwjV7eMXQwHkAHcQ8idThEfXdYZvoucZUeQx293GcwXkW8bp9Nvh5Aq/57qrUAKPfRVT00xgoDdz/xLkEP4H251mBcKxkbcExICMlWY7GrI+4JA6+ceA/Uy3fSenM4Z2KWmUj4NNPMVBDvkYE3h3jquvFfDldtqsE4TrxZBl6rQyDNBtsC4ilZImEa8ZS8x296mWEw5kxhkvV9DoGozCghh3hqTAmZxPs1nEDYwdwAgahbp+mcSjgELAbS5bi0WH3mG3gtISytTmip7n1ZaDBuc9zsnFGkts5gu9Fxs88lXjv033FJvyeJp9SqCTWWII5a7OqJe9zxZ92XcreSIRLKiNejDzFYBmvWe6ZPP5tmQmEKgG80hhKUEg4Q76IkUW4bjDMEiXIYqcMR6vuTJfE0EXeztN5URplg6GA3cfsDSvgkSnTmSXha9TBEY6FJxscseb5D2GhO5RlLym2nPj9rhyVUEve99+5+2nF5KWwQbmmrAwTCsmQQwBoLn5eV0oDGq+6AJQ1z4Gp5zQwQyDwqQdVauEXCT1zgd07c8LnVqcJZg65uBIWalZs6G9mKD43k40OXu/igLmSnC0qFM0ktcyepHrdoqtFENoDX5NsTU4FOYYlQMr2M8HFV2MOL/Iy4NKTaDoSHasEfW0L4hyxduvca/gGQh9HHDD2215dnlgN7CPIFeZ+K0uhIUnOC5LrpZmrNEsmqxhWEhwbtQ7dFRDotszCWFCMvoAyKECFCBKQX/gJxoy16UK2GEAAAAABJRU5ErkJggg==);

.live-icon {
    width: 17.5px;
    height: 27px;
    display: inline-flex;
    filter: drop-shadow(2px 2px 2px var(--text-shadow-color));

    @media screen and (max-width: 767px) {
        width: 18px;
        height: 16px;
    }

    @media screen and (max-width: 400px) {
        height: 19px;
    }
}

.live-icon > div {
    background-color: var(--text-color);
    -webkit-mask-image: $url-icon;
    -webkit-mask-size: contain;
    -webkit-mask-repeat: no-repeat;
    mask-image: $url-icon;
    mask-size: contain;
    mask-repeat: no-repeat;
}

.live-icon > div > img {
    -webkit-mask-image: $url-icon;
    mask-image: $url-icon;
}
</style>